export const BUSINESS = {
  name: "Simpliq Atelier",
  tagline: "Bespoke handmade furniture",
  address: "9671 Jane St, Vaughan, ON L6A 3X5",
  email: "Simpliq.inc@gmail.com",
  phone: "+1647 620 8315",
  phoneHref: "tel:+16476208315",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1705326701287-346fc37a2c86?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  living: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  dining: "https://images.unsplash.com/photo-1740759546813-6b58d44f5dce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  bedroom: "https://images.unsplash.com/photo-1616594092403-fb65629b0a46?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  office: "https://images.unsplash.com/photo-1704655295066-681e61ecca6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  craft1: "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  craft2: "https://images.unsplash.com/photo-1631396326838-de37e5f8bcbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  wood: "https://images.unsplash.com/photo-1628229894555-21320be9a9c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  process: "https://images.pexels.com/photos/7058414/pexels-photo-7058414.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
};

export const NAV = [
  { label: "Collections", to: "collections" },
  { label: "Atelier", to: "manifesto" },
  { label: "Process", to: "process" },
  { label: "Enquire", to: "contact" },
];

export const COLLECTIONS = [
  { n: "01", title: "Living", desc: "Sofas, seating & statement pieces built for a lifetime of gathering.", img: IMAGES.living },
  { n: "02", title: "Dining", desc: "Solid-timber tables and chairs, joined by hand, finished by eye.", img: IMAGES.dining },
  { n: "03", title: "Bedroom", desc: "Beds, casegoods and quiet forms that soften a private world.", img: IMAGES.bedroom },
  { n: "04", title: "Office", desc: "Desks and commercial millwork engineered for daily rigor.", img: IMAGES.office },
];

export const CHAPTERS = [
  { n: "I", title: "Made by hand, not by machine", body: "Every commission begins at the bench. Our makers cut, join and finish each piece individually — no assembly line, no compromise. The mark of the hand is the mark of the maker." },
  { n: "II", title: "Timber chosen for a century", body: "We source slow-grown hardwoods for their grain, stability and character. A Simpliq piece is built to be repaired, re-oiled and passed down — never discarded." },
  { n: "III", title: "Designed around you", body: "Dimensions, joinery, finish and hardware are yours to decide. From a single dining table to a full commercial fit-out, we design to the room and the ritual." },
];

export const PROCESS = [
  { n: "01", title: "Consultation", body: "We meet in the showroom or on-site to understand the space, the use and the vision." },
  { n: "02", title: "Design & drawing", body: "Detailed drawings, material samples and a fixed quotation before a single cut is made." },
  { n: "03", title: "The bench", body: "Your piece is built by a single lead maker, joined by hand and finished over weeks." },
  { n: "04", title: "Delivery & care", body: "White-glove delivery, installation, and a lifetime relationship for care and repair." },
];

export const TESTIMONIALS = [
  { quote: "The dining table they built anchors our entire home. Ten years from now it will only look better.", name: "Amara & Louis", role: "Private residence, Forest Hill" },
  { quote: "We fitted three boardrooms through Simpliq. The craftsmanship reads as quiet confidence to every client who walks in.", name: "Devon Reyes", role: "Managing Partner, Kline & Co." },
  { quote: "They listened, drew, and delivered exactly the bed we described. Faultless from first call to installation.", name: "Priya Menon", role: "Private residence, Vaughan" },
];

export const MARQUEE = ["Handmade in Vaughan", "Bespoke commissions", "Solid hardwood", "Residential & commercial", "Built for a lifetime"];
